export const trainingContent = {
  registrationHeader: 'The Bambee Core Training Bundle',
  standardPricePerCourse: '$7.99',
  purchaseButtonText: 'Purchase Training',
  registrationHeaderIntro: 'Employee Training',
  manualStaffPrompt:
    'Enter the number of employees to purchase training seats for.',
  purchaseAgreement:
    '<p>By purchasing, you agree to the Bambee training terms of service. Total: {{ TOTAL_PRICE }} for {{ EMPLOYEE_COUNT }} employees at {{ PRICE_PER_COURSE }} per course.</p>',
  registrationSubheader:
    '<p>Keep your team compliant with essential workplace training courses.</p>',
  purchaseInProgress:
    '<p>Please wait while we process your training bundle purchase...</p>',
  purchaseButtonTextWithVariables: 'Purchase for {{ TOTAL_PRICE }}',
};

export default trainingContent;
